import CustomCard from './utils/card';
import { Carousel } from "@material-tailwind/react";
import { useEffect, useState } from 'react';
import client from '../client/Client';
import Testimonials from './testimonials';

interface CarouselItem {
  _id: string,
  Place: string,
  Date: string,
  SSDEditionNumber: string,
  image: {
    asset: {
      _ref: string
    }
  },
  SSDVersionYear: string,
  SSDURL: string,
  Description: string
}

export default function Hero() {
  const [ssdVersionData, setssdVersionData] = useState<CarouselItem[]>([])
  const [callForPapers, setCallForPapers] = useState("")
  
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []); 

  useEffect(() => {
    const pathD = "M8.25 4.5l7.5 7.5-7.5 7.5";
    const button = document.querySelector(`button svg path[d="${pathD}"]`)?.closest('button') as HTMLButtonElement;
    if (isMounted) {
      if (button) {
        button.click();
      }
    }
  }, [isMounted]);

  const welcomeParagraph = [
    "The International Multi-Conference on Systems, Signals and Devices (SSD) co-sponsored by IEEE focuses on research, development and applications associated with the field of Electrical Engineering and Information Technology.",
    "The 24th edition SSD'27 will be held in Tunis, Tunisia from 22nd to 25th March 2027"
  ];

  useEffect(() => {
    client.fetch('*[_type == "WelcomeParagh"]')
    .then((result) => {
        if(result[0]?.CallForPapers?.asset?._ref){
          setCallForPapers(result[0]?.CallForPapers?.asset?._ref)
        }
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [callForPapers])

  useEffect(() => {
    client.fetch('*[_type == "SSDVersion"]')
      .then((result) => {
        result.sort(function (a: any, b: any) {
          return +b.SSDVersionYear.slice(-2) - +a.SSDVersionYear.slice(-2);
        });
        setssdVersionData(result.reverse())
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, [callForPapers])

  return (
    <section className="relative">
      {/* Illustration behind hero content */}
      <div className="fixed left-1/2 transform -translate-x-1/2 bottom-0 pointer-events-none -z-1" aria-hidden="true">
        <svg width="1360" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>

      {/* Hero content */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-20 md:pt-28 pb-8 md:pb-12">
          <div className="text-center">
            {/* Responsive heading with smaller mobile text */}
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight tracking-tighter mb-6 md:mb-8 px-2" data-aos="zoom-out">
              The International Multi-Conference on Systems, Signals and Devices 
            </h1>
            
            <div className="max-w-full flex flex-col justify-center items-center mx-auto">
              <div className="px-4 sm:px-0">
                {welcomeParagraph.length > 0 &&
                  welcomeParagraph.map((item, index) => (
                    <p 
                      key={index} 
                      className="text-center text-sm sm:text-base md:text-lg lg:text-xl text-gray-600 mb-4 md:mb-8 max-w-3xl leading-relaxed"
                      data-aos="fade-in" 
                      data-aos-delay="200"
                    >
                      {item}
                    </p>
                  ))
                }
              </div>
              
              {/* Responsive buttons with smaller mobile text */}
              <div className='flex flex-col sm:flex-row items-center gap-3 sm:gap-4 w-full sm:w-auto px-4 sm:px-0'>
                <a 
                  href={callForPapers ? `https://cdn.sanity.io/files/79vgbaej/production/${callForPapers.slice(5, -4) + "." + callForPapers.slice(-3)}`:""}  
                  className='transition text-sm sm:text-base md:text-lg font-semibold text-red-500 bg-white border-2 border-red-500 rounded-lg shadow-md px-4 sm:px-6 py-3 hover:bg-red-500 hover:text-white hover:shadow-lg transform hover:-translate-y-0.5 duration-200 w-full sm:w-auto text-center'
                >
                  Call For Papers
                </a>
                <a 
                  href='#dates-section' 
                  className='transition text-sm sm:text-base md:text-lg font-semibold text-red-500 bg-white border-2 border-red-500 rounded-lg shadow-md px-4 sm:px-6 py-3 hover:bg-red-500 hover:text-white hover:shadow-lg transform hover:-translate-y-0.5 duration-200 w-full sm:w-auto text-center'
                >
                  Important Dates
                </a>
              </div>

              {/* Testimonials with responsive margin */}
              <div className="w-full  md:mb-6 px-4 sm:px-0">
                <Testimonials />
              </div>

              {/* Responsive Carousel with INCREASED MOBILE HEIGHT */}
              <div className="w-full px-2 sm:px-0" data-aos="fade-in" data-aos-delay="200">
                <Carousel
                  loop={true}
                  transition={{type:"tween",duration:0.6}}
                  className="rounded-xl w-full max-w-4xl mx-auto h-[35rem] sm:h-[28rem] md:h-[35rem] lg:h-[45rem] shadow-md"
                  navigation={({ setActiveIndex, activeIndex, length }) => {
                    return (
                      <div className="absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2">
                        {new Array(length).fill("").map((_, i) => (
                          <span
                            key={i}
                            className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${activeIndex === i ? "bg-white w-6 sm:w-8" : "bg-white/50 w-3 sm:w-4"}`}
                            onClick={() => setActiveIndex(i)}
                          />
                        ))}
                      </div>
                    )
                  }}
                >
                  {ssdVersionData.length > 0 && ssdVersionData.map(({ _id, Place, Date, SSDEditionNumber, image, SSDVersionYear, SSDURL, Description }, index) => (
                    <div key={_id} className="h-full w-full">
                      <CustomCard 
                        index={index} 
                        _id={_id} 
                        Place={Place} 
                        Description={Description} 
                        image={image} 
                        Date={Date} 
                        SSDVersionYear={SSDVersionYear} 
                        SSDURL={SSDURL} 
                        SSDEditionNumber={SSDEditionNumber} 
                      />
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}